import React, { useLayoutEffect, useRef, useState } from 'react';
interface A4FrameProps {
  children: React.ReactNode;
  width?: number;
  className?: string;
}

/** Renders fixed-width paper content scaled down to fit its container. */
export function A4Frame({
  children,
  width = 794,
  className = ''
}: A4FrameProps) {
  const outerRef = useRef<HTMLDivElement>(null);
  const innerRef = useRef<HTMLDivElement>(null);
  const [scale, setScale] = useState(1);
  const [height, setHeight] = useState(1123);
  useLayoutEffect(() => {
    const outer = outerRef.current;
    const inner = innerRef.current;
    if (!outer || !inner) return;
    const update = () => {
      setScale(Math.min(1, outer.clientWidth / width));
      setHeight(inner.offsetHeight);
    };
    update();
    const ro = new ResizeObserver(update);
    ro.observe(outer);
    ro.observe(inner);
    return () => ro.disconnect();
  }, [width]);
  return <div ref={outerRef} className={`w-full ${className}`} style={{
    height: height * scale
  }} data-id="element-223" data-mp="2jh0pu46ambkf">
      <div ref={innerRef} className="print-reset" style={{
      width,
      transform: `scale(${scale})`,
      transformOrigin: 'top left'
    }} data-id="element-224" data-mp="jxynzp57wiat">
        {children}
      </div>
    </div>;
}